import axios from "axios";

export const api = axios.create({
  baseURL: "https://blogs.dwebbox.com/api/v1",
});
